// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"ce7ad67c","365":"69269c17","665":"5dfab0cf","675":"d847f835","719":"c25e3ff3","765":"dff2f1ef","939":"78cf93f6"}[chunkId] + ".chunk.js";
};